export default "__VITE_ASSET__DCt657tg__"